// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller

import { application } from "./application"

import ApplicationController from "./application_controller.js"
application.register("application", ApplicationController)

import AnnouncementsController from "./announcements_controller.js"
application.register("announcement", AnnouncementsController)

import AppliesBulkController from "./applies_bulk_controller.js"
application.register("applies-bulk", AppliesBulkController)

import AttachmentDropzoneController from "./attachment_dropzone_controller.js"
application.register("attachment-dropzone", AttachmentDropzoneController)

import AutoSelectController from "./auto_select_controller.js"
application.register("auto-select", AutoSelectController)

import AutoSubmitController from "./auto_submit_controller.js"
application.register("auto-submit", AutoSubmitController)

import ApplicantSelectController from "./applicant_select_controller.js"
application.register("applicant-select", ApplicantSelectController)

import ApplyCtaController from "./apply_cta_controller.js"
application.register("apply-cta", ApplyCtaController)

import CarouselController from "./carousel_controller.js"
application.register("carousel", CarouselController)

import CheckboxController from "./checkbox_controller.js"
application.register("checkbox", CheckboxController)

import CmodalController from "./cmodal_controller.js"
application.register("cmodal", CmodalController)

import ColorPickerController from "./color_picker_controller.js"
application.register("color-picker", ColorPickerController)

import ConfettiController from "./confetti_controller.js"
application.register("confetti", ConfettiController)

import ConnectController from "./connect_controller.js"
application.register("connect", ConnectController)

import CustomersController from "./customers_controller.js"
application.register("customers", CustomersController)

import DateController from "./date_controller.js"
application.register("date", DateController)

import DatetimeController from "./datetime_controller.js"
application.register("datetime", DatetimeController)

import DesignerController from "./designer_controller.js"
application.register("designer", DesignerController)

import DynamicSelectController from "./dynamic_select_controller.js"
application.register("dynamic-select", DynamicSelectController)

import EmailPreviewerController from "./email_previewer_controller.js"
application.register("email-previewer", EmailPreviewerController)

import EmailValidatorController from "./email_validator_controller.js"
application.register("email-validator", EmailValidatorController)

import FileInputController from "./file_input_controller.js"
application.register("file-input", FileInputController)

import FileUploadController from "./file_upload_controller.js"
application.register("file-upload", FileUploadController)

import FiltersController from "./filters_controller.js"
application.register("filters", FiltersController)

import FollowerSearchController from "./follower_search_controller.js"
application.register("follower-search", FollowerSearchController)

import FlatpickrController from "./flatpickr_controller.js"
application.register("flatpickr", FlatpickrController)

import HelloController from "./hello_controller.js"
application.register("hello", HelloController)

import HovercardController from "./hovercard_controller.js"
application.register("hovercard", HovercardController)

import InfinitePageController from "./infinite_page_controller.js"
application.register("infinite-page", InfinitePageController)

import InlineEditController from "./inline_edit_controller.js"
application.register("inline-edit", InlineEditController)

import InteractionsController from "./interactions_controller.js"
application.register("interactions", InteractionsController)

import JobFormController from "./job_form_controller.js"
application.register("job-form", JobFormController)

import JobStatusButtonController from "./job_status_button_controller.js"
application.register("job-status-button", JobStatusButtonController)

import MeetingsController from "./meetings_controller.js"


import MentionsController from "./mentions_controller.js"
application.register("mentions", MentionsController)

import ModalController from "./bmodal_controller.js"
application.register("bmodal", ModalController)

import NestedFormController from "./nested_form_controller.js"
application.register("nested-form", NestedFormController)

import NotificationsController from "./notifications_controller.js"
application.register("notifications", NotificationsController)

import OnboardingController from "./onboarding_controller.js.erb"
application.register("onboarding", OnboardingController)

import PasswordToggleController from "./password_toggle_controller.js"
application.register("password-toggle", PasswordToggleController)

import Pdf_reader_controller from "./pdf_reader_controller";
application.register("pdf-reader", Pdf_reader_controller)

import RatingsController from "./ratings_controller.js"
application.register("ratings", RatingsController)

import RangeSliderController from "./range_slider_controller.js"
application.register("range-slider", RangeSliderController)

import RejectApplyController from "./reject_apply_controller.js"
application.register("reject-apply", RejectApplyController)

import RemoteFormController from "./remote_form_controller.js"
application.register("remote-form", RemoteFormController)

import RemovalsController from "./removals_controller.js"
application.register("removals", RemovalsController)

import ReloadController from "./reload_controller.js"
application.register("reload", ReloadController)

import ResetFormController from "./reset_form_controller.js"
application.register("reset-form", ResetFormController)

import ResizableController from "./resizable_controller.js"
application.register("resize", ResizableController)

import SearchController from "./search_controller.js"
application.register("search", SearchController)

import SearchFilterController from "./search_filter_controller.js"
application.register("search-filter", SearchFilterController)

import SelectController from "./select_controller.js"
application.register("select", SelectController)

import SelectTitleController from "./select_title_controller.js"
application.register("select-title", SelectTitleController)

import SortableController from "./sortable_controller.js"
application.register("sortable", SortableController)

import SortableSelectController from "./sortable_select_controller.js"
application.register("sortable-select", SortableSelectController)

import TableHighlightController from "./table_highlight_controller";
application.register("table-highlight", TableHighlightController)

import TagsController from "./tags_controller";
application.register("tags", TagsController)

import Talentfinder_controller from "./talentfinder_controller.js"
application.register("talentfinder", Talentfinder_controller)

import TemplatesController from "./templates_controller.js"
application.register("templates", TemplatesController)

import TimeController from "./time_controller.js"
application.register("time", TimeController)

import TmodalController from "./tmodal_controller.js"
application.register("tmodal", TmodalController)

import ToastrController from "./toastr_controller.js"
application.register("toastr", ToastrController)

import SelectRevealController from "./select_reveal_controller.js"
application.register("select-reveal", SelectRevealController)

import SelectUserController from "./select_user_controller.js"
application.register("select-user", SelectUserController)

import TomselectController from "./tomselect_controller.js"
application.register("tomselect", TomselectController)

import TomselectColoredController from "./tomselect_colored_controller.js"
application.register("tomselect-colored", TomselectColoredController)

import TomselectCreateController from "./tomselect_create_controller.js"
application.register("tomselect-create", TomselectCreateController)

import TomselectSearchController from "./tomselect_search_controller.js"
application.register("tomselect-search", TomselectSearchController)

import TurbolinksFormController from "./turbolinks_form_controller.js"
application.register("turbolinks-form", TurbolinksFormController)

import UnsavedChangesController from "./unsaved_changes_controller"
application.register("unsaved-changes", UnsavedChangesController)

import ValidationController from "./validation_controller.js"
application.register("validation", ValidationController)

import VideoController from "./video_controller.js"
application.register("video", VideoController)

import ViewPreferencesController from "./view_preferences_controller.js"
application.register("view-preferences", ViewPreferencesController)